import Server from "./index";

export default class ExchangesCardServer extends Server {
  constructor() {
    super("/exchanges_card.php");
  }

  public get(params?: undefined): Promise<any> {
    return super.get(null);
  }
}
